import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  stack: { width: '100%' },
  alertWidth: { width: '100%' },
  message: {
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
  },
}));
